<template>
  <div class="d-flex flex-column">
    <input-control
      type="horizontal"
      v-model.trim="treatment.name"
      labelClass="col-md-3 col-lg-2"
      required
      maxLength="255"
    >
      Treatment Name
    </input-control>
    <input-control
      type="horizontal"
      v-model.trim="treatment.description"
      control="textarea"
      rows="6"
      maxLength="500"
      labelClass="col-md-3 col-lg-2"
    >
      Description
    </input-control>
    <div class="form-group d-flex flex-md-row flex-column">
      <label class="col-md-3 col-lg-2 px-0"> Treatment Length </label>
      <select required v-model="treatment.duration" class="form-control">
        <option
          v-for="option in treatmentLengths"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <div class="form-group d-flex flex-md-row flex-column">
      <label class="col-md-3 col-lg-2 px-0"> Scheduled Length </label>
      <div>
        <select
          required
          v-model="treatment.scheduled_duration"
          class="form-control"
        >
          <option
            v-for="option in treatmentLengths"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <small class="text-muted mt-2">
          The duration for which the staff member's schedule is reserved. Set
          this longer than the treatment duration to provide a break between
          treatments. Set it shorter than the treatment duration to enable
          overlapping appointments.
        </small>
      </div>
    </div>
    <div class="form-group row">
      <label
        for="available-for-booking-id"
        class="col-form-label col-12 col-md-3 col-lg-2"
      >
        Available for Booking?
      </label>
      <div class="col">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input pointer-cursor"
            id="available-for-booking-id"
            v-model="treatment.available_for_booking"
          />
          <label
            class="custom-control-label pointer-cursor"
            for="available-for-booking-id"
          >
            {{ treatment.available_for_booking ? "Yes" : "No" }}
          </label>
        </div>
      </div>
    </div>
    <div class="form-group d-flex flex-md-row flex-column">
      <label class="col-md-3 col-lg-2 px-0 align-self-start mt-1">
        {{ $filters.providerLabel("plural", true) }}/Admins
      </label>
      <div class="col">
        <inline-multi-select
          v-model="treatment.provider_ids"
          :options="usersToList"
          :placeholder="`Search by admin/${$filters.providerLabel({
            type: 'singular',
            capitalize: false,
          })} name`"
          :noResultMessage="`No admins/${$filters.providerLabel({
            type: 'plural',
            capitalize: false,
          })} found`"
        >
          <template v-slot:label="{ item }">
            <div class="d-flex flex-column">
              <div class="font-weight-bold select-label">
                {{ item.label }}
              </div>
              <small
                class="text-muted small email-container"
                style="opacity: 0.9"
              >
                ({{ item.email }})
              </small>
            </div>
          </template>
        </inline-multi-select>
        <small class="text-muted mt-2">
          Select
          {{ $filters.providerLabel("plural", false) }} who can perform this
          treatment. It will appear in their online booking area once assigned.
        </small>
      </div>
    </div>
    <div class="form-group d-flex flex-md-row flex-column">
      <label class="col-md-3 col-lg-2 px-0"></label>
      <div class="w-100">
        <div class="alert alert-info mb-0">
          <i class="fa fa-info-circle"></i>
          Non-billable treatments will only appear in the personal booking area
          of the assigned
          {{ $filters.providerLabel("plural", false) }}
          listed above. They will not be shown in the public booking area.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InlineMultiSelect from "@/components/InlineMultiSelect.vue";
import { mapState } from "vuex";

export default {
  name: "NonBillableServiceFields",
  components: {
    InlineMultiSelect,
  },
  props: {
    treatment: {
      type: Object,
      required: true,
    },
    treatmentLengths: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.treatment.price = 0;
  },
  computed: {
    ...mapState({
      usersWithRoles: (state) => state.security.usersWithRoles,
    }),
    usersToList: function () {
      return this.usersWithRoles
        .filter((user) => {
          return [1, 2, 5].includes(user.roleId) && user.status === "ACTIVE";
        })
        .map((user) => {
          return {
            label: user.name,
            value: user.user_id,
            email: user.email,
          };
        });
    },
  },
};
</script>
